import { render, staticRenderFns } from "./ticket-badge.vue?vue&type=template&id=744ebf8b&scoped=true"
import script from "./ticket-badge.vue?vue&type=script&lang=js"
export * from "./ticket-badge.vue?vue&type=script&lang=js"
import style0 from "./ticket-badge.vue?vue&type=style&index=0&id=744ebf8b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744ebf8b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('744ebf8b')) {
      api.createRecord('744ebf8b', component.options)
    } else {
      api.reload('744ebf8b', component.options)
    }
    module.hot.accept("./ticket-badge.vue?vue&type=template&id=744ebf8b&scoped=true", function () {
      api.rerender('744ebf8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jackpot/ticket-badge.vue"
export default component.exports